// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import ReactTooltip from 'react-tooltip'

import style from './Tooltip.scss';

type Props = {
  +intl: string;
  +id: string;
};

export default class Tooltip extends Component<Props> {

  render() {
    const { intl, id } = this.props;
    return (<section className={style.tooltip}>
      <div className={style.tooltipIcon}
           data-tip={this.context.intl.formatMessage({ id: intl })} data-for={id}>?</div>
      <ReactTooltip id={id} place="top" className={style.tooltipBox}/>
    </section>);
  }
}

Tooltip.propTypes = {
  intl: PropTypes.string,
  id: PropTypes.string,
};

Tooltip.contextTypes = {
  intl: intlShape,
};




// WEBPACK FOOTER //
// ./src/elements/Tooltip/Tooltip.jsx